
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import { createApolloClient } from "lib/apollo/apollo"
import getEntry from "lib/apollo/queries/entry"
import getHeaderAndFooter from "lib/apollo/queries/globals"
import Layout from "components/Layout"
import DynamicContent from "components/DynamicContent"
import fetchSlugs from "../lib/apollo/queries/slugs"

function CatchAllPage({ content = {}, globals = {} }) {
  return (
    <Layout globals={globals} content={content}>
      <DynamicContent content={content} />
    </Layout>
  )
}

 const _getServerSideProps = async ({ params = null, previewData = null }) => {
  const apollo = createApolloClient(previewData?.token ?? null)

  const uri = params?.slug ? `/${params.slug.join("/")}` : "/"

  const [content, globals] = await Promise.all([
    getEntry(apollo, "pages", uri, previewData?.token || false),
    getHeaderAndFooter(apollo),
  ])

  if (!content || !globals) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      content,
      globals,
    },
    // revalidate: 30,
  }
}

/*export const getStaticPaths = async () => {
  let paths = await fetchSlugs("pages")

  // These pages get handled separately
  let ignoredSlugs = [
    "bauantragscheck",
    "virtueller-assistent",
    "architekt-on-demand",
  ]

  paths = paths.filter(
    (path) =>
      path.params.slug.length &&
      ignoredSlugs.indexOf(path.params.slug[0]) === -1
  )

  return {
    paths,
    fallback: false,
  }
}*/

export default CatchAllPage


    export async function getServerSideProps(ctx) {
        let res = _getServerSideProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/[...slug]',
              loaderName: 'getServerSideProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  